import { ConfigService, configServiceFactory } from './config.service';
import { LayersService } from './layers.service';
import { HttpErrorHandler } from './http-error-handler.service';
import { MessageService } from './message.service';
import { SearchService } from './search.service';
import { BasemapsService } from './basemap.service';
import { FeaturesService } from './features.service';
import { MetadataService } from './metadata.service';
import { PrintService } from './print.service';
import { ArcGisService } from './arcgis.service';
import { EditFeatureService } from './editfeature.service';
import { AppSettingsService } from './appsettings.service';
import { PropertiesService } from './properties.service';
import { WMRPService } from './wmrp.service';

export const services: any[] = [
  { provide: ConfigService, useFactory: configServiceFactory() },
  LayersService,
  HttpErrorHandler,
  MessageService,
  SearchService,
  BasemapsService,
  FeaturesService,
  MetadataService,
  PrintService,
  ArcGisService,
  EditFeatureService,
  AppSettingsService,
  PropertiesService,
  WMRPService
];

export * from './config.service';
export * from './layers.service';
export * from './http-error-handler.service';
export * from './message.service';
export * from './search.service';
export * from './basemap.service';
export * from './features.service';
export * from './metadata.service';
export * from './print.service';
export * from './arcgis.service';
export * from './editfeature.service';
export * from './appsettings.service';
export * from './properties.service';
export * from './wmrp.service';


// Import tracking service directly in app.module.ts to prevent circular dependency
// export * from './tracking/tracking.service';
